/** Throttle delay for tree node selection clicks (ms). */
export const THROTTLE_SELECTION_MS = 80;

/** Scroll event debounce when animations are enabled in the tree root (ms). */
export const DEBOUNCE_SCROLL_ANIMATED_MS = 100;

/** Scroll event debounce when animations are disabled (ms) in the tree root. */
export const DEBOUNCE_SCROLL_MS = 15;

/** Intersection-observer debounce for content scroll-top detection (ms). */
export const DEBOUNCE_CONTENT_SCROLL_TOP_MS = 100;

/** CSS transition cleanup delay for split pane resize — must exceed the 0.2s transition (ms). */
export const TIMEOUT_SPLIT_TRANSITION_CLEANUP_MS = 210;

/** Pointerdown detection timeout for SearchBar (ms). */
export const SEARCH_POINTERDOWN_TIMEOUT_MS = 10;

/** Office selection-handler debounce (ms). */
export const DEBOUNCE_EDITOR_SELECTION_MS = 300;

/** Office selection-handler debounce multiplier. */
export const DEBOUNCE_EDITOR_SELECTION_MULTIPLIER = 2;

/** Office update-pipeline debounce (ms). */
export const DEBOUNCE_UPDATE_PIPELINE_MS = 1500;

/** Office update-pipeline debounce multiplier. */
export const DEBOUNCE_UPDATE_PIPELINE_MULTIPLIER = 3;

/** Minimum floor for ProgressiveDebounce (ms). */
export const MIN_PROGRESSIVE_DEBOUNCE_MS = 250;
